import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Workflow } from 'src/app/models';
import { WorkflowService } from 'src/app/services';

@Component({
  selector: 'wm-template-library-editor',
  templateUrl: './template-library-editor.component.html',
  styleUrl: './template-library-editor.component.css',
  standalone: false
})
export class TemplateLibraryEditorComponent {
  workflows: Workflow[] = [];
  archivedWorkflows: Workflow[] = [];
  useMockData = false;
  isLoading = false;

  constructor(
    private _workflowSvc: WorkflowService,
    private _router: Router
  ) { }

  ngOnInit() {
    this.loadWorkflows();
  }

  loadWorkflows() {
    this.isLoading = true;

    this._workflowSvc.getTemplateLibraryWorkflows()
      .subscribe(response => {
        this.workflows = response.filter(w => !w.isArchived);

        this.archivedWorkflows = response.filter(w => w.isArchived);

        this.isLoading = false;
      });
  }

  archiveWorkflow(e) {
    this.loadWorkflows();
  }

  restoreWorkflow(e) {
    this.loadWorkflows();
  }

  enableWorkflow(e) {
    const wf = this.workflows.find(w => w.id == e);

    if (wf) {
      wf.isEnabled = true;
    }
  }

  disableWorkflow(e) {
    const wf = this.workflows.find(w => w.id == e);

    if (wf) {
      wf.isEnabled = false;
    }
  }

  createWorkflow() {
    this._router.navigate(['admin', 'global', 'template-library', 'add']);
  }
}
